import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const API_BASE_URL = "https://church-backend-48tj.onrender.com";



function SermonsPage() {

  const [selectedSermon, setSelectedSermon] = useState(null);
const [sermons, setSermons] = useState([]);



 useEffect(() => {
    // socket live adds
    const socket = io(API_BASE_URL, { transports: ['websocket'] });
    socket.on('connect', () => { /* connected */ });
    socket.on('getsermon', (prod) => { if (prod) setSermons(prev => [prod, ...prev]); });
       socket.on('updatesermon', (prod) => { if (prod) setSermons(prev => [prod, ...prev]); });
    
socket.on('deletesermon', (id) => {
   setSermons(prev =>
      prev.filter(item => item._id !== id)
   );
});

    return () => socket.disconnect();
  }, []);


const getSermons = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/sermons`);

        if (!response.ok) {
            throw new Error("Failed to fetch sermons");
        }

        const data = await response.json();

        setSermons(data);

    } catch (err) {
        console.error(err);
    }
};


useEffect(() => {
    getSermons();
}, []);

  return (
    <div className="page-shell">
      <section className="hero-banner hero-banner--compact" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1800&q=80)' }}>
        <div className="hero-overlay" />
        <div className="hero-content container">
        
          <h1>Get sermons.</h1>
          <p>Explore thoughtful teaching designed to guide daily life and deepen spiritual clarity.</p>
        </div>
      </section>

{/*

      <section className="featured-sermon-section">

  <div className="featured-sermon-card">

    <div className="featured-sermon-image">

      <img
        src="https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=1800&q=80"
        alt="Featured Sermon"
      />

      <div className="featured-badge">

        FEATURED MESSAGE

      </div>

    </div>

    <div className="featured-sermon-content">

      <p className="featured-label">

        MATTHEW 14:22–33

      </p>

      <h2>

        The God
        Who Never
        Fails

      </h2>

      <p className="featured-description">

        Storms are inevitable, but fear doesn't have to be.
        Discover how faith grows stronger when we keep our eyes
        on Jesus instead of our circumstances.

      </p>

      <div className="featured-meta">

        <div>

          <strong>Speaker</strong>

          <span>Rev. John Doe</span>

        </div>

        <div>

          <strong>Date</strong>

          <span>Sunday • 6 July 2026</span>

        </div>

        <div>

          <strong>Reading Time</strong>

          <span>12 Minutes</span>

        </div>

      </div>

      <button
        className="button button--primary"
        onClick={() => setSelectedSermon(sermons[0])}
      >
        Read Today's Message
      </button>

    </div>

  </div>

</section>
*/}


<section className="section sermon-library-section">

  <div className="container">

    <div className="section-heading">
      <p className="eyebrow">Sermon Library</p>
      <h2>Discover messages that strengthen faith and transform everyday life.</h2>
      <p className="section-copy">
        Every message is prayerfully prepared to encourage, teach and lead you
        closer to Christ. Choose a sermon below and begin reading.
      </p>
    </div>

    <div className="sermons-preview-grid">

      {sermons.map((item) => (

        <article
          key={item.id}
          className="sermon-library-card"
          onClick={() => setSelectedSermon(item)}
        >

          <div className="sermon-library-image">

             <img
    src={item.image}
    alt={item.title}
/>

            <div className="sermon-library-overlay">

              <span className="reading-time">
                {item.readingTime}
              </span>

            </div>

          </div>

          <div className="sermon-preview-content">

            <span className="sermon-date">
              {item.date}
            </span>

            <h3>
              {item.title}
            </h3>

            <p>

              {item.introduction.substring(0,120)}...

            </p>

            <div className="sermon-footer">

              <div>

                <small>Speaker</small>

                <strong>{item.speaker}</strong>

              </div>

              <button>

                Read →

              </button>

            </div>

          </div>

        </article>

      ))}

    </div>

  </div>

</section>

    

      {selectedSermon && (

<div
className="reader-backdrop"
onClick={()=>setSelectedSermon(null)}
>

<div
className="reader-sheet"
onClick={(e)=>e.stopPropagation()}
>

<button
className="reader-close"
onClick={()=>setSelectedSermon(null)}
>

✕

</button>

<div
className="reader-cover"
style={{
backgroundImage:`url(${selectedSermon.image})`
}}
>

<div className="reader-cover-overlay"/>

<div className="reader-cover-content">

<span>

{selectedSermon.readingTime}

</span>

<h1>

{selectedSermon.title}

</h1>

<p>

{selectedSermon.scripture}

</p>

</div>

</div>

<div className="reader-body">

<div className="reader-author">

<div>

<h3>

{selectedSermon.speaker}

</h3>

<p>

{selectedSermon.date}

</p>

</div>

</div>

<div className="reader-scripture">

<h2>

Today's Scripture

</h2>

<p>

{selectedSermon.keyVerse}

</p>

</div>

<div className="reader-point">

<h2>

Introduction

</h2>

<p>

{selectedSermon.introduction}

</p>

</div>

{selectedSermon.sections.map(section=>(

<section
key={section.title}
className="reader-point"
>

<h2>

{section.title}

</h2>

<p>

{section.content}

</p>

</section>

))}

<div className="reader-quote">

<p>

❝

{selectedSermon.quote}

❞

</p>

</div>



<div className="reader-prayer">

<h2>

Closing Prayer

</h2>

<p>

{selectedSermon.prayer}

</p>

</div>

</div>

</div>

</div>

)}

    </div>
  );
}

export default SermonsPage;
